import { Component } from '@angular/core';

import { pedidoReprovado } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-reprovado',
    templateUrl: './pedido-status-badge-reprovado.component.html',
    styleUrls: ['./pedido-status-badge-reprovado.component.less']
})
export class PedidoStatusBadgeReprovadoComponent {
    status = pedidoReprovado;
}
